import styled from "@emotion/styled";

export const TitlePage = styled.h1({
  marginTop: "1em",
  marginLeft: "1em",
  fontSize: "44px",
  marginBottom: "0.7em",
  "@media screen and (max-width: 992px)": {
    display: "none",
  },
});

export const TitleCategory = styled.p({
  fontSize: "21px",
  marginTop: "2.5em",
  paddingLeft: "15px",
  position: "relative",
  marginBottom: "20px",
  textTransform: "capitalize",
  fontWeight: "600",
  "&:first-child": {
    marginTop: "0",
  },
  "&:before": {
    left: "0",
    width: "5px",
    content: '""',
    height: "100%",
    background: "black",
    position: "absolute",
  },
  "@media screen and (max-width: 992px)": {
    fontSize: "16px",
    fontWeight: "400",
  },
});

export const ItemMap = styled.div({
  marginTop: "15px",
  marginBottom: "15px",
  ".ReactCollapse--collapse .ReactCollapse--content": {
    "@media screen and (max-width: 992px)": {
      display: "flex",
      flexDirection: "column-reverse",
    },
  },
});

export const MobileDetailMedia = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    position: "relative",
  },
});

export const MobileDetailIndex = styled.span({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "10px",
    left: "0",
    minWidth: "22px",
    height: "22px",
    padding: "0 6px",
    borderRadius: "4px",
    background: "#000",
    color: "#fff",
    fontSize: "11px",
    fontWeight: "700",
    lineHeight: 1,
    zIndex: "2",
  },
});

export const MobileDetailText = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    marginBottom: "10px",
  },
});

export const TitleItem = styled.p({
  display: "flex",
  fontSize: "20px",
  marginBottom: "10px",
  alignItems: "center",
  marginTop: "10px",
  b: {
    fontWeight: "400",
    display: "flex",
    alignItems: "center",
    "@media screen and (max-width: 992px)": {
      fontWeight: "400",
      display: "inline",
    },
  },
  small: {
    cursor: "pointer",
    marginLeft: "1em",
    marginRight: "1em",
    fontSize: "15px",
    fontWeight: "500",
    svg: {
      fontSize: "10px",
    },
    "@media screen and (max-width: 992px)": {
      fontSize: "12px",
      marginLeft: "0em",
      marginRight: "1em",
    },
  },
  ".bussiness-tag": {
    cursor: "default !important",
    color: "#9E9E9E",
    fontSize: "14px",
    padding: "0 4px",
    marginLeft: "5px",
    background: "white",
    display: "inline-block",    
    fontWeight: "400",
    "@media screen and (max-width: 992px)": {
      fontSize: "11px",
      marginTop: "0px"      
    },
  },
  span: {
    cursor: "pointer",
    color: "white",
    fontSize: "15px",
    padding: "0 8px",
    marginLeft: "10px",
    background: "#000",
    "@media screen and (max-width: 992px)": {
      fontSize: "12px",
      marginLeft: "0",
    },
  },
  "@media screen and (max-width: 992px)": {
    fontSize: "14px",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  ".detail-buttons": {
    display: "flex",
    "@media screen and (max-width: 992px)": {
      fontSize: "14px",
      marginTop: "8px",
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
});

export const DescriptionItem = styled.p({
  fontSize: "14px",
  lineHeight: "25px",
  letterSpacing: "0.5px",
  a: {
    color: "#5591ef",
  },
});

export const ImgContentItem = styled.div({
  display: "flex",
  flexWrap: "wrap",
  "@media screen and (max-width: 992px)": {
    flexDirection: "row",
    marginBottom: "10px",
  },
});

export const ImgItem = styled.div({
  width: "50%",
  margin: "20px 0",
  paddingLeft: "30px",
  "&:first-child": {
    paddingLeft: "0",
    paddingRight: "30px",
  },
  img: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    cursor: "pointer",
  },
  "@media screen and (max-width: 992px)": {
    width: "50%",
    paddingLeft: "6px",
    margin: "8px 0",
    "&:first-child": {
      paddingLeft: "0",
      paddingRight: "6px",
    },
  },
});

export const MobileCategoryTabs = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    gap: "18px",
    overflowX: "auto",
    padding: "0 20px",
    scrollbarWidth: "none",
    alignItems: "center",
    height: "100%",
    
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const MobileCategoryTab = styled.button({
  border: "0",
  background: "transparent",
  padding: "0",
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
    height: "28px",
    padding: "0 0 8px",
    color: "#9E9E9E",
    fontSize: "13px",    
    borderBottom: "3px solid transparent",
  },
  '&[data-active="true"]': {
    "@media screen and (max-width: 992px)": {
      color: "#000",
      borderBottomColor: "#000",
    },
  },
});

export const MobileCategoryHeader = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    background: "#F5F5F5",
    padding: "14px 20px",
    marginBottom: "14px",
  },
});

export const MobileCategoryLine = styled.span({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    width: "3px",
    height: "14px",
    background: "#000",
    flexShrink: 0,
  },
});

export const MobileCategoryTitle = styled.span({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "15px",
    lineHeight: 1.2,
    fontWeight: "600",
    textTransform: "uppercase",
    color: "#111",
    flex: 1,
  },
});

export const MobileCategoryCount = styled.span({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    fontSize: "12px",
    color: "#666",
    fontWeight: "500",
    whiteSpace: "nowrap",
    textTransform: "lowercase",
  },
});

export const MobileStickyCategories = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
    height: "70px",
    background: "#fff",
    zIndex: 200,
    paddingTop: "8px",
    paddingBottom: "8px",
    borderBottom: "1px solid #E5E5E5",
    '&[data-fixed="true"]': {
      position: "fixed",
      top: "65px",
      left: 0,
      right: 0,
    },
  },
});

export const MobileListContainer = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    width: "100%",
    height: "auto",
    minHeight: 0,
    overflow: "visible",
  },
});

export const MobileItemsScroll = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    width: "100%",
    height: "auto",
    minHeight: 0,
    overflow: "visible",
  },
});

export const MobileItemsList = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    flexDirection: "column",
    gap: "12px",    
  },
});

export const MobileItemCard = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
    padding: "0 20px",
    paddingBottom: "10px",    
    borderBottom: "1px solid #E5E5E5"
  },
  '&[data-open="true"]': {
    "@media screen and (max-width: 992px)": {
      borderBottom: "0",
      paddingBottom: "0",
    },
  },
});

export const MobileItemImage = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    width: "92px",
    minWidth: "92px",
    height: "92px",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#f3f3f3",
    transition: "opacity 220ms ease, transform 220ms ease, width 220ms ease, min-width 220ms ease, margin 220ms ease",
    img: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
      cursor: "pointer",
    },
  },
  '&[data-open="true"]': {
    "@media screen and (max-width: 992px)": {
      opacity: 0,
      width: "0",
      minWidth: "0",
      height: "0",
      overflow: "hidden",
      transform: "translateY(6px)",
    },
  },
});

export const MobileItemBody = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
});

export const MobileItemTitleRow = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "700",
    marginBottom: "6px",
    minHeight: "18px",
  },
});

export const MobileItemIndex = styled.span({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "18px",
    height: "18px",
    borderRadius: "4px",
    background: "#000",
    color: "#fff",
    fontSize: "11px",
    fontWeight: "700",
    lineHeight: 1,
    padding: "0 4px",
    flexShrink: 0,
  },
});

export const MobileItemTitle = styled.p({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    margin: 0,
    color: "#111",
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "bold",
  },
});

export const MobileItemBusiness = styled.p({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    margin: "0 0 10px",
    color: "#9E9E9E",
    fontSize: "12px",
    lineHeight: 1.3,
    fontWeight: "bold"
  },
});

export const MobileItemActions = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginTop: "auto",
    span: {
      cursor: "pointer",
      color: "#fff",
      fontSize: "12px",
      fontWeight: "700",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      height: "40px",
      padding: "0 14px",
      borderRadius: "6px",
      background: "#000",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      lineHeight: 1,
      svg: {
        fontSize: "15px",
        flexShrink: 0,
      },
    },
    small: {
      cursor: "pointer",
      color: "#000",
      fontSize: "12px",
      fontWeight: "600",
      height: "40px",
      padding: "0 16px",
      background: "#F0F0F0",
      borderRadius: "6px",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      margin: 0,
      svg: {
        display: "none",
      },
    },
  },
  '&[data-open="true"]': {
    "@media screen and (max-width: 992px)": {
      display: "none",
    },
  },
});

export const MobileDetailSection = styled.div({
  display: "none",
  "@media screen and (max-width: 992px)": {
    display: "block",
    padding: "0 20px",
    paddingBottom: "18px",
    borderBottom: "1px solid #E5E5E5",
    animation: "fadeInMobileDetail 220ms ease",
    transformOrigin: "top center",
    "@keyframes fadeInMobileDetail": {
      from: {
        opacity: 0,
        transform: "translateY(-4px)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  },
  "> div:last-child": {
    "@media screen and (max-width: 992px)": {
      marginTop: "16px",
      marginBottom: "6px",
    },
  },
});

export const TtitleIndex = styled.p({
  fontSize: "16px",
});
export const IndexList = styled.ul({});

export const MapToggleButton = styled.button({
  display: "none",
  "@media screen and (max-width: 992px)": {
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "6px",
    right: "6px",
    zIndex: "3",
    border: "0",
    background: "#000",
    color: "#fff",
    fontSize: "14px",
    padding: "0",
  },
});

export const ImageModalOverlay = styled.div({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.88)",
  zIndex: "9999",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  animation: "fadeInImageOverlay 260ms ease forwards",
  "@keyframes fadeInImageOverlay": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
});

export const ImageModalContent = styled.div({
  position: "relative",
  width: "100%",
  maxWidth: "900px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  animation: "zoomInImageModal 320ms cubic-bezier(0.22, 1, 0.36, 1) forwards",
  transformOrigin: "center center",
  "@keyframes zoomInImageModal": {
    from: {
      opacity: 0,
      transform: "scale(0.88) translateY(14px)",
    },
    to: {
      opacity: 1,
      transform: "scale(1) translateY(0)",
    },
  },
  img: {
    width: "100%",
    maxHeight: "90vh",
    objectFit: "contain",
    animation: "zoomInImage 360ms cubic-bezier(0.22, 1, 0.36, 1) forwards",
    transformOrigin: "center center",
    boxShadow: "0 24px 70px rgba(0, 0, 0, 0.45)",
    "@keyframes zoomInImage": {
      from: {
        opacity: 0,
        transform: "scale(0.92)",
      },
      to: {
        opacity: 1,
        transform: "scale(1)",
      },
    },
  },
});

export const ImageModalClose = styled.button({
  position: "absolute",
  top: "12px",
  right: "12px",
  width: "30px",
  height: "30px",
  border: "0",
  borderRadius: "999px",
  background: "rgba(0, 0, 0, 0.82)",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  lineHeight: 1,
  fontSize: "18px",
  padding: "0",
  cursor: "pointer",
  zIndex: "2",
  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.24)",
  opacity: 0,
  animation: "fadeInCloseButton 280ms ease forwards",
  animationDelay: "360ms",
  svg: {
    display: "block",
  },
  "@keyframes fadeInCloseButton": {
    from: {
      opacity: 0,
      transform: "scale(0.85) translateY(-4px)",
    },
    to: {
      opacity: 1,
      transform: "scale(1) translateY(0)",
    },
  },
});

export const MobilePinModalOverlay = styled.div({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.45)",
  zIndex: 300,
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  padding: "0",
  animation: "fadeInPinOverlay 220ms ease forwards",
  "@keyframes fadeInPinOverlay": {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  "@media screen and (min-width: 993px)": {
    display: "none",
  },
});

export const MobilePinModalContent = styled.div({
  position: "relative",
  width: "100%",
  maxHeight: "78vh",
  background: "#fff",
  borderRadius: "20px 20px 0 0",
  padding: "12px 20px 60px 20px",
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
  animation: "slideUpPinModal 280ms cubic-bezier(0.22, 1, 0.36, 1) forwards",
  transformOrigin: "bottom center",
  "@keyframes slideUpPinModal": {
    from: {
      opacity: 0,
      transform: "translateY(40%)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  "@media screen and (min-width: 993px)": {
    display: "none",
  },
  "> div:last-child": {
    marginTop: "16px",
    marginBottom: "6px",
  },
});

export const MobilePinModalHandle = styled.div({
  width: "40px",
  height: "4px",
  borderRadius: "999px",
  background: "#D1D1D1",
  margin: "0 auto 16px",
});

export const MobilePinModalHeader = styled.div({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "12px",
  marginBottom: "14px",
});

export const MobilePinModalTitleGroup = styled.div({
  flex: 1,
  minWidth: 0,
});

export const MobilePinModalIndex = styled.span({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "22px",
  height: "22px",
  padding: "0 6px",
  borderRadius: "4px",
  background: "#000",
  color: "#fff",
  fontSize: "11px",
  fontWeight: "700",
  lineHeight: 1,
  marginBottom: "8px",
});

export const MobilePinModalTitle = styled.h3({
  margin: 0,
  color: "#111",
  fontSize: "18px",
  lineHeight: "24px",
  fontWeight: "700",
});

export const MobilePinModalBusiness = styled.p({
  margin: "6px 0 0",
  color: "#9E9E9E",
  fontSize: "13px",
  lineHeight: 1.4,
});

export const MobilePinModalClose = styled.button({
  width: "32px",
  height: "32px",
  border: 0,
  borderRadius: "999px",
  background: "#F0F0F0",
  color: "#111",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  padding: 0,
  cursor: "pointer",
  flexShrink: 0,
  svg: {
    display: "block",
  },
});

export const MobilePinModalDescription = styled.div({
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "0.3px",
  color: "#333",
  a: {
    color: "#5591ef",
  },
  "> p": {
    margin: 0,
  },
});

export const MapContent = styled.div({
  // top: "75px",
  width: "45%",
  height: "calc(100vh - 197px)",
  position: "relative",
  top: "-140px",
  "@media screen and (max-width: 992px)": {
    order: 1,
    width: "100%",
    paddingLeft: "0",
    margin: "0",
    top: "0",
    position: "relative",
    zIndex: 1,
    overflow: "hidden",
    flex: "0 0 70vh",
    height: "70vh",
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    paddingBottom: "0",
  },
});

export const MainContent = styled.div({
  width: "55%",
  paddingRight: "2em",
  "@media screen and (max-width: 992px)": {
    order: 2,
    width: "100%",
    paddingRight: "0",
    height: "auto",
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    paddingTop: "0",
    overflow: "visible",
    position: "relative",
    zIndex: 5,
  },
});

export const FluidContent = styled.div({
  ".stycky-content": {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    padding: "0 2em",
    "@media screen and (max-width: 992px)": {
      flexDirection: "column",
      padding: "0",
    },
  },

  "@media screen and (max-width: 992px)": {
    padding: "0",
    marginBottom: "0",
  },
});
